import type { ReactNode } from 'react'
import { LearningLessonShellHeader } from './LearningLessonShell'
import './learning-exercise-toolbar.css'

function joinClassNames(...classNames: Array<string | undefined>) {
  return classNames.filter(Boolean).join(' ')
}

function normalizeProgress(progress: number) {
  return Math.min(100, Math.max(0, progress))
}

export interface LearningExerciseToolbarProps {
  readonly backSlot: ReactNode
  readonly className?: string
  readonly leftSlotClassName?: string
  readonly progress: number
  readonly progressLabel: string
  readonly progressTrackClassName?: string
  readonly progressValueClassName?: string
  readonly rightSlot?: ReactNode
  readonly rightSlotClassName?: string
  readonly centerSlotClassName?: string
  readonly toolbarClassName?: string
}

export function LearningExerciseToolbar({
  backSlot,
  className,
  centerSlotClassName,
  leftSlotClassName,
  progress,
  progressLabel,
  progressTrackClassName,
  progressValueClassName,
  rightSlot,
  rightSlotClassName,
  toolbarClassName,
}: LearningExerciseToolbarProps) {
  const normalizedProgress = normalizeProgress(progress)

  return (
    <LearningLessonShellHeader className={className}>
      <div className={joinClassNames('learningExerciseToolbar', toolbarClassName)}>
        <div className={joinClassNames('learningExerciseToolbarLeft', leftSlotClassName)}>{backSlot}</div>
        <div className={joinClassNames('learningExerciseToolbarCenter', centerSlotClassName)}>
          <div
            aria-label={progressLabel}
            aria-valuemax={100}
            aria-valuemin={0}
            aria-valuenow={Math.round(normalizedProgress)}
            className={joinClassNames('learningExerciseProgress', progressTrackClassName)}
            role="progressbar"
          >
            <div
              className={joinClassNames('learningExerciseProgressValue', progressValueClassName)}
              style={{ width: `${normalizedProgress}%` }}
            />
          </div>
        </div>
        <div className={joinClassNames('learningExerciseToolbarRight', rightSlotClassName)}>{rightSlot}</div>
      </div>
    </LearningLessonShellHeader>
  )
}
